import {AxiosClientFactory} from "../../common/helpers/AxiosClientFactory";
import {CommandResult} from "../../common/helpers/CommandResult";

export const deleteCampaign = (id: number): Promise<CommandResult> => {
    return AxiosClientFactory
        .getInstance()
        .delete(`/api/campaigns/${id}`)
        .then((result) => new CommandResult(result));
};